import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Analisis/peticionDeleteDataSwine`, method: 'POST', body: values, token: token})
}
